import { CountMinSketch, JsBloom, Raw } from '.';
import { index, Profile } from './indexing';

export function anonymize(raw: Raw): Profile {
  const counts = new CountMinSketch();
  const bloom = new JsBloom({ size: 10000 });
  const profile = { counts, bloom };

  raw.events?.forEach((e) => {
    index(profile, e);
  });

  raw.pageViews?.map((view) => {
    index(profile, view);
  });

  index(profile, raw.traits ?? {});
  index(profile, { account_score: raw.accountScore });
  index(profile, { company: raw.firmographics });
  index(profile, { person: raw.person });

  return profile;
}
